import { Button, Modal, Spinner } from "react-bootstrap";
import React, { useState, useCallback, useEffect } from "react";
import { CALL_IMAGE } from "../../../../context/constValues";

const ModalCuentaAdmin = (props) => {
  const {
    estado,
    onCloseModal,
    item = {},
    onReturnValue,
    isnew
  } = props;
  const maxFileSize = 5 * 1024 * 1024; // 5 MB en bytes
  const toBoolean = (value) => value === "true";
  const [fotoPreview, setFotoPreview] = useState();
  const [fotodefault, setDefault] = useState();
  const [formData, setFormData] = useState({
    idadmin: item.idadmin || "",
    cuenta: item.cuenta || "",
    contraseña: item.contraseña || "",
    nombre: item.nombrecompleto || "",
    cedula: item.cedula || "",
    foto: item.foto || null, // Mantener el nombre de la imagen existente
    accesos: {
      Cuentas: toBoolean(item?.cuentas) || false,
      Usuarios: toBoolean(item?.usuarios) || false,
      Sesiones: toBoolean(item?.sesiones) || false,
      Cierres: toBoolean(item?.cierres) || false,
      Opciones: toBoolean(item?.opciones) || false,
      Contacto: toBoolean(item?.contacto) || false,
      "Editar Enfermeria": toBoolean(item?.editarenfermeria) || false
    }
  });
  const [errorFoto, setErrorFoto] = useState("");
  const [isLoadingFoto, setIsLoadingFoto] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (errorFoto || isLoadingFoto) {
      return;
    }
    const datosFinales = {
      idadmin: formData.idadmin || item.idadmin,
      cuenta: formData.cuenta || item.cuenta,
      nombre: formData.nombre || item.nombre,
      cedula: formData.cedula || item.cedula,
      foto: formData.foto, // Enviar el archivo nuevo o el nombre de la imagen existente
      accesos: formData.accesos
    };
    // Solo incluir contraseña al crear un nuevo usuario
    if (isnew) {
      datosFinales.contraseña = formData.contraseña || item.contraseña;
    }
    onReturnValue(datosFinales, isnew);
  };

  const handleAccesoChange = (acceso) => {
    setFormData({
      ...formData,
      accesos: {
        ...formData.accesos,
        [acceso]: !formData.accesos[acceso]
      }
    });
  };

  const assigmentValueAdmin = useCallback(async () => {
    setIsLoadingFoto(true);
    try {
      // Cargar imagen existente si está disponible (modo edición)
      if (item.foto && !isnew) {
        const res = await fetch(`${CALL_IMAGE}${item.foto}`);
        if (res.ok) {
          const imageBlob = await res.blob();
          const imageObjectURL = URL.createObjectURL(imageBlob);
          setFotoPreview(imageObjectURL);
        } else {
          throw new Error("No se pudo cargar la imagen existente");
        }
      }
      // Cargar imagen por defecto
      const res2 = await fetch(`${CALL_IMAGE}images/defaultimg.png`);
      if (res2.ok) {
        const imageBlob2 = await res2.blob();
        const imageObjectURL2 = URL.createObjectURL(imageBlob2);
        setDefault(imageObjectURL2);
        // Usar imagen por defecto si no hay imagen existente en modo edición
        if (!item.foto || isnew) {
          setFotoPreview(imageObjectURL2);
        }
      } else {
        throw new Error("No se pudo cargar la imagen por defecto");
      }
    } catch (error) {
      console.error("Error cargando imágenes:", error);
      setErrorFoto("Error al cargar la imagen.");
    } finally {
      setIsLoadingFoto(false);
    }
  }, [item.foto, isnew]);

  useEffect(() => {
    assigmentValueAdmin();
  }, [assigmentValueAdmin]);

  const handleFotoChange = (event) => {
  const file = event.target.files[0];
  setErrorFoto("");
  if (file) {
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      setErrorFoto("Solo se permiten archivos PNG, JPG o JPEG.");
      setFormData({ ...formData, foto: item.foto || null });
      setFotoPreview(fotodefault);
      event.target.value = "";
      return;
    }
    if (file.size > maxFileSize) {
      setErrorFoto("La imagen no debe exceder los 5 MB.");
      setFormData({ ...formData, foto: item.foto || null });
      setFotoPreview(fotodefault);
      event.target.value = "";
      return;
    }
    setIsLoadingFoto(true);
    setFormData({ ...formData, foto: file });
    const reader = new FileReader();
    reader.onload = (e) => {
      setFotoPreview(e.target.result);
      setIsLoadingFoto(false);
    };
    reader.onerror = () => {
      setErrorFoto("Error al cargar la imagen.");
      setIsLoadingFoto(false);
    };
    reader.readAsDataURL(file);
  } else {
    setFormData({ ...formData, foto: item.foto || null });
    setFotoPreview(item.foto && !isnew ? `${CALL_IMAGE}${item.foto}` : fotodefault);
  }
};

  return (
    <>
      <Modal show={estado} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Registro de Cuenta Administrativa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} id="auFORM">
            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Foto
                <input
                  type="file"
                  className="form-control"
                  accept="image/png,image/jpeg,image/jpg"
                  onChange={handleFotoChange}
                  disabled={isLoadingFoto}
                />
                {errorFoto && <div className="text-danger mt-1">{errorFoto}</div>}
              </label>
              <div className="mt-2 text-center" style={{ minHeight: "150px" }}>
                {isLoadingFoto ? (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                ) : (
                  <img
                    src={fotoPreview || fotodefault}
                    alt="Vista previa"
                    style={{ maxWidth: "150px", maxHeight: "150px", objectFit: "cover", borderRadius: "50%" }}
                  />
                )}
              </div>
            </div>
            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Cuenta
                <span className="text-danger">*</span>
                <input
                  className="form-control"
                  required
                  value={formData.cuenta}
                  onChange={(e) => setFormData({ ...formData, cuenta: e.target.value })}
                />
              </label>
            </div>
            {isnew && (
              <div className="form-group mb-2 row">
                <label className="col-form-label">
                  Contraseña
                  <span className="text-danger">*</span>
                  <input
                    type="password"
                    className="form-control"
                    required
                    value={formData.contraseña}
                    onChange={(e) => setFormData({ ...formData, contraseña: e.target.value })}
                  />
                </label>
              </div>
            )}
            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Nombre completo
                <span className="text-danger">*</span>
                <input
                  type="text"
                  className="form-control"
                  required
                  value={formData.nombre}
                  onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                />
              </label>
            </div>
            <div className="form-group mb-2 row">
              <label className="col-form-label">
                Cédula
                <span className="text-danger">*</span>
                <input
                  type="text"
                  className="form-control"
                  required
                  value={formData.cedula}
                  onChange={(e) => setFormData({ ...formData, cedula: e.target.value })}
                />
              </label>
            </div>
            <div className="form-group mb-2">
              <label className="col-form-label">Accesos</label>
              <div className="row">
                {Object.keys(formData.accesos).map((acceso) => (
                  <div className="col-6" key={acceso}>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={formData.accesos[acceso]}
                        onChange={() => handleAccesoChange(acceso)}
                      />
                      <label className="form-check-label">{acceso}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onCloseModal}>
            Cerrar
          </Button>
          <Button type="submit" form="auFORM" disabled={isLoadingFoto}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalCuentaAdmin;